{
    "UserMenu_Notifications": "Notifications",
    "UserMenu_UserTour": "Démarrer la visite éducative des utilisateurs",
    "UserMenu_ShowInsights": "Afficher le tableau de bord Insights",
    "UserMenu_HideInsights": "Masquer le tableau de bord Insights",
    "UserMenu_ChangePassword": "Changer le mot de passe",
    "UserMenu_ChangeLanguage": "Changer de langue",
    "UserMenu_Timezone": "Changer de fuseau horaire",
    "UserMenu_Help": "Aide",
    "UserMenu_ClearContentful": "Vider le cache de contenu",
    "UserMenu_ChangeBrowserProfile": "Modifier le profil du navigateur",
    "UserMenu_Resources": "Ressources",
    "UserMenu_Resources_Terms": "Conditions générales",
    "UserMenu_Resources_CookiePolicy": "Politique relative aux cookies",
    "UserMenu_Resources_PrivacyPolicy": "politique de confidentialité",
    "UserMenu_Logout": "Déconnexion",
    "NAME": "UserMenu"
}